export const CoronaVirusSelfCheckerType = 'CoronaVirusSelfChecker';
